import { EmptyArray } from '../../../app/domain/models/empty/empty';
import { getConflictedSales, resolveConflict } from '../../../usecases/documents-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';

export function enviarMensaje() {
    var telefono = '3042250026';
    var mensaje = 'Hola%20me%20gustaria%20activar%20la%20factura%20electronica';
    var link = 'https://wa.me/' + telefono + '?text=' + mensaje;
    window.open(link);
}

export function base64ToUint8Array(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

export function createPdfBlob(base64) {
    const byteArray = base64ToUint8Array(base64);
    return new Blob([byteArray], { type: 'application/pdf' });
}

export function createPdfUrl(blob) {
    return URL.createObjectURL(blob);
}

/**
 * Mapea las ventas en conflicto para la tabla
 */
export function conflictedSalesMapper(data) {
    if (!data || data.length === 0) return EmptyArray;

    return data.map((item) => ({
        date: item.date,
        customer: item.customer,
        document: item.prefix && item.number ? `${item.prefix}-${item.number}` : 'N/A',
        total: item.total,
        error_message: item.error_message || '',
        bill_id: item.bill_id,
        conflict_type: item.conflict_type || 'API_EXCEPTION',
        thirds_id: item.thirds_id,
        customer_id: item.customer_id,
        _original: item,
    }));
}

/**
 * Obtiene la lista de ventas en conflicto
 */
export async function getConflictedSalesList(page, limit) {
    try {
        const data = await getConflictedSales('', '', page, limit, true);
        if (!data.data || data.data.length === 0) {
            return { ...data, data: EmptyArray };
        }
        return { ...data, data: conflictedSalesMapper(data.data) };
    } catch (error) {
        console.error('Error fetching conflicted sales:', error);
        throw error;
    }
}

/**
 * Resuelve una venta en conflicto
 */
export async function handleResolveConflict(bill_id, force_generate = false) {
    try {
        const uid = localStorage.getItem('uid');
        const cid = localStorage.getItem('cid');

        dispatchCustomEvent('loading-btn');
        const response = await resolveConflict(uid, cid, bill_id, force_generate);
        dispatchCustomEvent('loading-btn');

        if (response?.data?.requires_confirmation) {
            return { requires_confirmation: true, message: response.message };
        }

        dispatchCustomEvent('popup', { message: response.message || "Conflicto resuelto", type: "success" });
        return { success: true };
    } catch (error) {
        dispatchCustomEvent('loading-btn');
        const msg = error.response?.data?.message || "Error al resolver conflicto";
        dispatchCustomEvent('popup', { message: msg, type: "error" });
        return { success: false, error: msg };
    }
}

